import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CFormGroup,
  CLabel,
  CTextarea
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class OccurrenceTypeCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // edit: false,
      loading: false,
      // roles: [],
      // types: [true],
      // studentSelected: [],
      // students: [],
      // rooms: [],
      // schools: [],
      // regions: [],
      // groups: [],
      selectedRoles: [],
      // selectedType: [],
      // selectedDisciplines: [],
      // disciplinesModal: false,
      code: "",
      description: ""
      // usersEdit: []
    };

    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;

    // puxar lista de tipos
    const params = {
      group_id: this.props.general.active_roles.group_id
    };

    axios
      .get(`${URL.api}communication/occurrence_type/list`, {
        params,
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        const result = resp.data.data.map(item => ({
          value: item.id,
          label: item.description
        }));

        this.setState({
          // types: result
        });
      });

    if (id) {
      axios
        .get(`${URL.api}communication/occurrence_type/singleView/${id}`, {
          headers: {
            authorization: `Bearer ${this.props.user.token}`
          }
        })
        .then(
          resp => {
            this.setState(
              {
                code: resp.data.data.code,
                description: resp.data.data.description
                // selectedType: [
                //   {
                //     type_id: resp.data.data.type_id
                //   }
                // ],
                // usersEdit: resp.data.data.users
              },
              () => {
                this.setState({
                  // edit: true,
                  loading: false
                });
              }
            );
          },
          error => {
            this.error(error.response.statusText);
          }
        );
    }

    // Atualizar lista de Turma
    axios
      .get(
        `${URL.api}community/room/list?class=true&school[]=${this.props.general.active_roles.school_id}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(resp => {
        if (resp.data.success) {
          let turmas = [];
          resp.data.data.map(room => {
            let obj = { label: room.name, value: room.id };
            turmas.push(obj);
          });
          // eslint-disable-next-line react/no-unused-state
          this.setState({ rooms: turmas });
        }
      });
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  validator(validator) {
    for (let i = 0; i < validator.length; i++) {
      if (!validator[i].value) {
        toastr.error("Erro", `Favor preencher o campo ${validator[i].label}`);
        return false;
      }
    }

    return true;
  }

  enviar() {
    let users = [];
    this.state.selectedRoles.map(item => {
      if (item.student_id != null) users.push(item.student_id);
    });

    const obj = {
      code: this.state.code,
      description: this.state.description,
      group_id: this.props.general.active_roles.group_id
    };

    axios
      .post(`${URL.api}communication/occurrence_type/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/occurrence_type/list");
      });
  }

  atualizar() {
    const obj = {
      code: this.state.code,
      description: this.state.description,
      group_id: this.props.general.active_roles.group_id
    };

    const { id } = this.props.match.params;

    axios
      .post(`${URL.api}communication/occurrence_type/update/${id}`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/occurrence_type/list");
      });
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/occurrence/me", to: "/occurrence/me" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.props.currentRoute === 205
                    ? "Editar Tipo de Ocorrência"
                    : "Criar Tipo de Ocorrência"}
                </h4>
                <div className="small text-muted">
                  {this.props.currentRoute === 205
                    ? "Edite o tipo de ocorrência selecionado"
                    : "Crie um novo tipo de ocorrência"}
                </div>
              </div>
              <CButton
                color="primary"
                onClick={() =>
                  // 204 -> Create | 205 -> Edit
                  this.props.currentRoute === 204
                    ? this.enviar()
                    : this.atualizar()
                }
              >
                <i className="fa fa-cloud-upload mr-2"></i>Salvar
              </CButton>
            </CCardHeader>
            <CCardBody>
              <CFormGroup>
                <CLabel>Código</CLabel>
                <CTextarea
                  placeholder="Digite o código da ocorrência"
                  rows={1}
                  value={this.state.code}
                  onChange={e => this.setState({ code: e.target.value })}
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel>Descrição</CLabel>
                <CTextarea
                  placeholder="Digite a descrição do tipo de ocorrência"
                  rows={4}
                  value={this.state.description}
                  onChange={e => this.setState({ description: e.target.value })}
                />
              </CFormGroup>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OccurrenceTypeCreate);
